<template>
  <page-wrapper :title="title" :has-pad="true">
    <draggable
      v-model="sorted"
      v-bind="dragOptions"
      class="list"
      @start="drag = true"
      @end="drag = false"
    >
      <transition-group :name="!drag ? 'flip-list' : null" type="transition">
        <div v-for="element in sorted" :key="element.id" class="item">
          <img :src="element.icon" class="icon" draggable="false" />
          {{ element.name }}
        </div>
      </transition-group>
    </draggable>
    <div class="text-end mt-4">
      <sc-button :disabled="saving" variant="primary" @click="handleClickSave">บันทึก</sc-button>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";

import draggable from "vuedraggable";

import { baanRueJaiClient, backendAdminClient } from "@/dependencies";

export default {
  components: {
    draggable,
    PageWrapper,
    ScButton,
  },
  data() {
    return {
      title: "จัดลำดับหมวดหมู่บริการ",
      sorted: [],
      drag: false,
      saving: false,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      }
    };
  },
  created() {
    this.setupList();
  },
  methods: {
    async setupList() {
      try {
        const response = await backendAdminClient.serviceCategory.getServiceCategoryList();
        this.sorted = response.data.result;
      } catch {
        this.$message.error("ไม่สามารถโหลดข้อมูลได้");
      }
    },
    async handleClickSave() {
      if (this.saving) return

      this.saving = true;
      try {
        await baanRueJaiClient.admin.subscriptions.serviceCategories.putOrder({
          ids: this.sorted.map(({ id }) => id)
        });
        this.$message.success("บันทึกเรียบร้อย");
      } catch {
        this.$message.error("ไม่สามารถเรียงลำดับได้");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}

.list {
  padding-bottom: 15px;
  overflow: auto;
}

.list > span {
  display: grid;
  grid-gap: 15px;
  grid-auto-flow: column;
  justify-content: flex-start;

  @media (max-width: 600px) {
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
  }

  > .item {
    border: 1px solid #e0e0e0;
    background: #fafafa;
    width: 100px;
    height: 100px;

    @media (max-width: 600px) {
      width: auto;
      height: auto;
    }
  }
}

.item {
  padding: 10px;

  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  font-size: 14px;

  cursor: pointer;

  @media (max-width: 600px) {
    flex-flow: row;
    justify-content: flex-start;
    padding: 5px 10px;
  }

  > .icon {
    margin-bottom: 5px;
    width: 48px;
    height: 48px;

    @media (max-width: 600px) {
      margin-bottom: 0;
      margin-right: 10px;
    }
  }
}
</style>
